import { render } from "./autonomySection.vue?vue&type=template&id=e79573ac"
import script from "./autonomySection.vue?vue&type=script&lang=js"
export * from "./autonomySection.vue?vue&type=script&lang=js"

import "./autonomySection.vue?vue&type=style&index=0&id=e79573ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__